export const GET_ONBOARDING = '@uhc/utility/GET_ONBOARDING';
export const SET_ONBOARDING = '@uhc/utility/SET_ONBOARDING';
